export default class DtoSensor {
    constructor(obj) {
        this.id = obj.id
        this.comment = obj.comment
        this.sensorType = obj.sensorType
        this.materielType = obj.sensorType
        this.purchaseDate = obj.purchaseDate
        this.warrantyTime = obj.warrantyTime
        this.manufactureDate = obj.manufactureDate
        this.withdrawalDate = obj.withdrawalDate
        this.providerId = obj.providerId
        this.range = obj.range
        this.length = obj.length
        this.cellNumber = obj.cellNumber
        this.height = obj.height
        this.serialNumber = obj.serialNumber
        this.jobExecutionId = obj.jobExecutionId
    }
}